// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1bp7A","range":"MonthRangeSwitch_range__K0OYr","disabled":"MonthRangeSwitch_disabled__2BTff"};